import { backendAPI } from "../../helper/apis";

// Digitar rotas sem BACKEND_URL, backendAPI ja possui essa URL base
export function getPGM() {
  return backendAPI.get("/pgm");
}

export function savePGM(data) {
  return backendAPI.put("/pgm", data);
}